export interface Category {
  id: number;
  name: string;
  slug: string;
  url: string;
  description: string;
  imageUrl: string;
  icon: string;
}

export const categories: Category[] = [
  {
    id: 1,
    name: 'Shoes',
    slug: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    description: 'Discover the latest sneakers, dress shoes, and casual footwear curated through comprehensive spreadsheet research',
    imageUrl: 'https://readdy.ai/api/search-image?query=High%20end%20product%20photography%20of%20designer%20sneakers%20displayed%20from%20top%20down%20angle%20on%20light%20sand%20textured%20surface%2C%20bright%20natural%20window%20light%20casting%20soft%20shadows%2C%20editorial%20fashion%20catalog%20composition%20with%20negative%20space%2C%20luxury%20modern%20aesthetic%2C%20crisp%20detail%20and%20refined%20color%20palette&width=600&height=480&seq=shoes-cat-v2-01&orientation=landscape',
    icon: 'ri-footprint-line',
  },
  {
    id: 2,
    name: 'Hoodies / Sweaters',
    slug: 'hoodies-sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    description: 'Browse cozy hoodies and premium sweaters from top-rated spreadsheet listings with detailed size guides',
    imageUrl: 'https://readdy.ai/api/search-image?query=Lifestyle%20product%20shot%20of%20an%20oversized%20knit%20sweater%20draped%20casually%20over%20a%20wooden%20chair%20near%20sunlit%20window%2C%20warm%20golden%20hour%20light%2C%20cozy%20atmospheric%20composition%20with%20soft%20bokeh%20background%2C%20Scandinavian%20interior%20aesthetic%2C%20serene%20and%20inviting%20visual%20mood&width=600&height=480&seq=hoodies-cat-v2-02&orientation=landscape',
    icon: 'ri-t-shirt-line',
  },
  {
    id: 3,
    name: 'T-Shirts',
    slug: 't-shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    description: 'Explore graphic tees, basics, and statement t-shirts organized by style, fit, and trending designs',
    imageUrl: 'https://readdy.ai/api/search-image?query=Creative%20flat%20lay%20of%20three%20folded%20premium%20cotton%20t-shirts%20in%20earthy%20neutral%20tones%20arranged%20in%20overlapping%20fan%20pattern%20on%20light%20ivory%20linen%2C%20soft%20diffused%20studio%20light%20from%20above%2C%20modern%20minimalist%20catalog%20aesthetic%2C%20clean%20geometric%20composition%2C%20subtle%20fabric%20texture%20visible&width=600&height=480&seq=tshirts-cat-v2-03&orientation=landscape',
    icon: 'ri-shirt-line',
  },
  {
    id: 4,
    name: 'Jackets',
    slug: 'jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    description: 'Find bomber jackets, denim jackets, and outerwear through detailed spreadsheet product comparisons',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20product%20photography%20of%20a%20tailored%20wool%20blend%20jacket%20hanging%20from%20a%20minimalist%20brass%20wall%20hook%20against%20soft%20greige%20wall%2C%20directional%20rim%20lighting%20creating%20dramatic%20silhouette%2C%20high%20fashion%20editorial%20style%2C%20refined%20contemporary%20boutique%20visual%2C%20sophisticated%20shadow%20play&width=600&height=480&seq=jackets-cat-v2-04&orientation=landscape',
    icon: 'ri-contrast-line',
  },
  {
    id: 5,
    name: 'Pants / Shorts',
    slug: 'pants-shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    description: 'Shop cargo pants, jeans, joggers, and shorts with accurate sizing data from spreadsheet research',
    imageUrl: 'https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20premium%20chino%20pants%20rolled%20elegantly%20with%20a%20leather%20belt%20on%20light%20oatmeal%20textured%20surface%2C%20morning%20sunlight%20streaming%20diagonally%2C%20editorial%20menswear%20composition%20with%20organic%20styling%2C%20modern%20sophisticated%20aesthetic%2C%20warm%20earth%20tone%20harmony&width=600&height=480&seq=pants-cat-v2-05&orientation=landscape',
    icon: 'ri-pantone-line',
  },
  {
    id: 6,
    name: 'Headwear',
    slug: 'headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    description: 'Discover caps, beanies, and bucket hats from verified spreadsheet sources with style ratings',
    imageUrl: 'https://readdy.ai/api/search-image?query=Creative%20angled%20shot%20of%20a%20premium%20structured%20cap%20floating%20against%20soft%20sage%20green%20background%20with%20subtle%20paper%20texture%2C%20studio%20lighting%20with%20gentle%20gradients%2C%20modern%20streetwear%20editorial%20aesthetic%2C%20clean%20graphic%20composition%2C%20bold%20and%20fresh%20visual%20impact&width=600&height=480&seq=headwear-cat-v2-06&orientation=landscape',
    icon: 'ri-base-station-line',
  },
  {
    id: 7,
    name: 'Sets',
    slug: 'sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    description: 'Browse coordinated outfit sets and matching apparel collections from top spreadsheet categories',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20flat%20lay%20of%20a%20complete%20monochrome%20outfit%20set%20including%20top%20and%20bottom%20arranged%20artistically%20on%20light%20terracotta%20linen%20backdrop%2C%20soft%20afternoon%20light%2C%20fashion%20editorial%20composition%20with%20thoughtful%20spacing%2C%20modern%20boutique%20catalog%20aesthetic%2C%20harmonious%20tonal%20palette&width=600&height=480&seq=sets-cat-v2-07&orientation=landscape',
    icon: 'ri-collage-line',
  },
  {
    id: 8,
    name: 'Underwear / Underpants',
    slug: 'underwear',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    description: 'Find premium underwear and basics with detailed material specs and comfort ratings',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20product%20shot%20of%20organic%20cotton%20basics%20neatly%20stacked%20in%20a%20woven%20rattan%20tray%20on%20pale%20blush%20surface%2C%20soft%20morning%20light%20filtering%20through%20sheer%20curtains%2C%20clean%20minimalist%20aesthetic%2C%20modern%20essential%20wear%20presentation%2C%20serene%20and%20refined%20atmosphere%20with%20botanical%20accent%20nearby&width=600&height=480&seq=underwear-cat-v2-08&orientation=landscape',
    icon: 'ri-user-heart-line',
  },
  {
    id: 9,
    name: 'Jersey',
    slug: 'jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    description: 'Explore sports jerseys, team apparel, and athletic wear through organized spreadsheet listings',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20diagonal%20product%20shot%20of%20a%20premium%20athletic%20jersey%20with%20bold%20graphic%20print%20displayed%20on%20light%20stone%20grey%20background%2C%20high%20contrast%20studio%20lighting%20with%20dramatic%20edge%20highlights%2C%20sports%20fashion%20editorial%2C%20energetic%20and%20modern%20composition%2C%20vivid%20color%20pop%20against%20neutral%20backdrop&width=600&height=480&seq=jersey-cat-v2-09&orientation=landscape',
    icon: 'ri-football-line',
  },
  {
    id: 10,
    name: 'Accessories',
    slug: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    description: 'Shop watches, sunglasses, jewelry, and fashion accessories from curated spreadsheet collections',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20flat%20lay%20of%20mixed%20fashion%20accessories%20including%20tortoiseshell%20sunglasses%20and%20a%20minimalist%20gold%20toned%20bracelet%20arranged%20on%20pale%20dove%20grey%20suede%20surface%2C%20soft%20directional%20light%20from%20left%2C%20editorial%20jewelry%20and%20accessory%20photography%2C%20refined%20modern%20elegance%2C%20delicate%20shadow%20detail%20and%20premium%20material%20contrast&width=600&height=480&seq=accessories-cat-v2-10&orientation=landscape',
    icon: 'ri-glasses-line',
  },
  {
    id: 11,
    name: 'Bags',
    slug: 'bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    description: 'Find backpacks, crossbody bags, and totes with detailed reviews from spreadsheet product data',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20three%20quarter%20angle%20of%20a%20structured%20canvas%20and%20leather%20tote%20bag%20placed%20on%20light%20sand%20colored%20surface%20near%20a%20sunlit%20window%2C%20soft%20natural%20daylight%2C%20lifestyle%20product%20photography%2C%20modern%20minimalist%20bag%20catalog%20aesthetic%2C%20warm%20and%20inviting%20composition%20with%20gentle%20shadows&width=600&height=480&seq=bags-cat-v2-11&orientation=landscape',
    icon: 'ri-handbag-line',
  },
  {
    id: 12,
    name: 'Belts',
    slug: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    description: 'Discover leather belts, casual belts, and designer options with material and sizing details',
    imageUrl: 'https://readdy.ai/api/search-image?query=Artistic%20close%20up%20product%20shot%20of%20a%20handcrafted%20leather%20belt%20with%20intricate%20buckle%20detail%20laid%20in%20an%20elegant%20S%20curve%20on%20light%20ecru%20textured%20paper%20surface%2C%20macro%20style%20with%20shallow%20depth%20of%20field%2C%20refined%20accessory%20photography%2C%20warm%20ambient%20lighting%2C%20sophisticated%20detail%20focused%20composition&width=600&height=480&seq=belts-cat-v2-12&orientation=landscape',
    icon: 'ri-link',
  },
  {
    id: 13,
    name: 'Perfumes',
    slug: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    description: 'Explore fragrance collections with scent notes, longevity data, and spreadsheet price comparisons',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ethereal%20product%20photography%20of%20an%20artisan%20glass%20perfume%20bottle%20with%20amber%20liquid%20on%20light%20alabaster%20surface%2C%20backlit%20with%20warm%20golden%20glow%20creating%20luminous%20reflections%2C%20luxury%20fragrance%20editorial%2C%20dreamy%20and%20sophisticated%20mood%2C%20soft%20focus%20botanical%20elements%20in%20background%2C%20refined%20atmospheric%20composition&width=600&height=480&seq=perfumes-cat-v2-13&orientation=landscape',
    icon: 'ri-drop-line',
  },
  {
    id: 14,
    name: 'Other Stuff',
    slug: 'other-stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    description: 'Browse miscellaneous finds, unique items, and trending products from diverse spreadsheet categories',
    imageUrl: 'https://readdy.ai/api/search-image?query=Curated%20eclectic%20flat%20lay%20of%20assorted%20lifestyle%20and%20fashion%20items%20including%20a%20notebook%20candle%20and%20small%20decorative%20objects%20on%20light%20warm%20grey%20background%2C%20soft%20diffused%20lighting%2C%20modern%20creative%20studio%20aesthetic%2C%20harmonious%20random%20arrangement%2C%20trending%20lifestyle%20visual%2C%20clean%20and%20fresh%20artistic%20composition&width=600&height=480&seq=other-cat-v2-14&orientation=landscape',
    icon: 'ri-more-line',
  },
];